/**
 * @generated SignedSource<<99937e3e21d0a7bfee854f4cd89a55f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedCategoryTabs_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCreatorsResultContainer_itemSearch">;
  readonly " $fragmentType": "SbSharedCategoryTabs_itemSearch";
};
export type SbSharedCategoryTabs_itemSearch$key = {
  readonly " $data"?: SbSharedCategoryTabs_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCategoryTabs_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedCategoryTabs_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedCreatorsResultContainer_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "1164f061ea84e3b21e1dfd2bb5ec2e14";

export default node;
